import { render, staticRenderFns } from "./ConfirmForgotPassword.vue?vue&type=template&id=d0914c24&"
import script from "./ConfirmForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ConfirmForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports